import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_INVITATIONS_APP_ROOT = `${BASE_ADMIN_V2_PATH}/invitations`;

export const ADMIN_INVITATIONS_APP_PATHS = {
  INVITATIONS_LIST: `${ADMIN_INVITATIONS_APP_ROOT}`,
  INVITATION_DETAILS: (invitationId: string) => `${ADMIN_INVITATIONS_APP_ROOT}/${invitationId}/details`,
};
